<template>
  <div>
    <Can I="delete" a="/ilim-edebiyat-yayini/IlimEdebiyatYayini">
      <b-modal
        id="modal-iy-delete"
        centered
        title="İlim Edebiyat Yayını Sil"
        ok-title="Sil"
        ok-variant="danger"
        header-bg-variant="danger"
        header-text-variant="white"
        cancel-title="İptal"
        cancel-variant="outline-secondary"
        @ok.prevent="remove"
        :busy="overlay">
        <p>{{ getMessage(339) }}</p>
      </b-modal>
    </Can>
    <div class="standart-page">
      <div class="row">
        <div class="col"></div>
        <div class="col"><h3 class="title">İLİM EDEBİYAT YAYINLARI</h3></div>
        <div class="col"></div>
      </div>
      <div class="card-component mb-5">
        <div class="body">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                    <label>Eser Adı</label>
                    <input type="text" class="form-control" v-model="form.eserAdi" maxlength="128">
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                    <label>ISBN</label>
                    <input type="text" class="form-control" v-model="form.isbn" maxlength="128">
                </div>
              </div>
              <div class="col-sm-3" v-if="$store.state.auth.user.mbId === 0">
                  <div class="form-group">
                    <label>Meslek Birliği</label>
                    <select v-select
                        class="form-control"
                        v-model="form.mbId">
                      <option :value="0" v-if="mblist.length > 1">Seçiniz</option>
                      <option :value="item.id"
                          v-for="(item,index) in mblist"
                          :key="index">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
              </div>
              <div class="col-sm-6" v-if="$store.state.auth.user.role !== 5">
                <div class="form-group">
                    <label>Hak Sahibi Adı</label>
                    <UyeAutoComplete v-model="form.hakSahibiAdSoyad" selectedTextColumnName="hakSahibiAdSoyad" selectedValueColumnName="uyeNo" isMember="true" inputclass="form-control" :model="form"/>
                </div>
              </div>
              <div class="col-sm-3" v-if="$store.state.auth.user.role !== 5">
                <div class="form-group">
                    <label>Üye No</label>
                    <input type="text" class="form-control" v-model="form.uyeNo" maxlength="128">
                </div>
              </div>
              <div class="col-sm-3" v-if="$store.state.auth.user.role !== 5">
                <div class="form-group">
                    <label>Vergi No</label>
                    <input type="text" class="form-control" v-model="form.vergiNo" v-mask="'###########'">
                </div>
              </div>
            </div>
        </div>
        <div class="footer d-flex justify-content-end">
          <button class="btn btn-outline-secondary mt-4" @click="clear">Temizle</button>
          <button class="btn btn-secondary mt-4" @click="search">Listele</button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Başlık</th>
              <th class="fit">ISBN</th>
              <th>Yayın Evi Adı</th>
              <th>Eser Çeşidi Adı</th>
              <th class="fit">Dil Adı</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in $store.state.iy.ilimEdebiyatYayini.liste" :key="index" class="cursor-pointer" @click="$router.push('/ilim-edebiyat-yayini/detay/' + item.eserId)">
              <td>{{item.eserAdi}}</td>
              <td class="fit">{{item.isbn}}</td>
              <td>{{item.yayinEviAdi}}</td>
              <td>{{item.eserCesidiAd}}</td>
              <td class="fit">{{item.dilAd}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="alert alert-danger text-center" v-if="showError">{{ errorMessage }}</div>
      <div class="row" v-if="$store.state.iy.ilimEdebiyatYayini.liste.length > 0">
        <div class="col">
          <i class="text-secondary">{{ $store.state.iy.ilimEdebiyatYayini.sayfalama.totalItems }} kayıttan {{ ((form.pageNum - 1) * form.pageSize) + 1 }} - {{ form.pageNum * form.pageSize }} arası gösterilmektedir</i>
        </div>
        <div class="col">
          <div class="row">
            <div class="col d-flex justify-content-end">
              <nav>
                <paginate v-if="$store.state.iy.ilimEdebiyatYayini.liste.length"
                          :page-count="$store.state.iy.ilimEdebiyatYayini.sayfalama.totalPages"
                          :click-handler="changePage"
                          :prev-text="'Önceki'"
                          :next-text="'Sonraki'"
                          :active-class="'active'"
                          :container-class="'pagination'"
                          v-model="form.pageNum">
                </paginate>
              </nav>
            </div>
            <div class="col-2">
              <select class="form-control" v-model="form.pageSize" @change="changeSize">
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import UyeAutoComplete from '@/components/UyeAutoComplete';

export default {
  components:{
    UyeAutoComplete
  },
  data() {
    return {
      prevRoute:null,
      errorMessage:'',
      showError: false,
      mblist:[],
      overlay: false,
      form: {
        mbId:this.$store.state.auth.user.mbId,
        eserAdi:"",
        hakSahibiAdSoyad:"",
        isbn:"",
        uyeNo:"",
        vergiNo:"",
        pageNum: 1,
        pageSize: 25
      }
    }
  },
  methods: {
    ...mapActions("general", ["showModal", "errorHandling", "fileUpload"]),
    ...mapActions('uye', ['getMBList']),
    ...mapActions('iy', ["searchIlimEdebiyatYayini"]),
    clear() {
      this.$store.state.iy.searchList = false;
      this.$store.state.iy.ilimEdebiyatYayini = Object.assign({}, {
        liste: [],
        sayfalama: {}
      });
      this.form = Object.assign({}, {
        pageNum: 1,
        pageSize: 25,
        mbId:this.$store.state.auth.user.mbId,
        eserAdi:"",
        hakSahibiAdSoyad:"",
        isbn:"",
        uyeNo:"",
        vergiNo:""
      });
      this.$store.state.iy.duplicateForm = Object.assign({}, this.form);
      this.showError = false;
    },
    changeSize() {
      this.list();
    },
    changePage(pageNumber) {
      this.form.pageNum = pageNumber;
      this.list();
    },
    search(){
      this.form.pageNum = 1;
      this.list();
    },
    list() {
      this.$store.state.iy.ilimEdebiyatYayini.liste = [];
      if (this.isEmptyFilterForm()) {
        this.showError = true;
        this.errorMessage = this.getMessage(140);
        return;
      }
      
      this.$store.state.iy.duplicateForm = Object.assign({}, this.form);
      this.$store.state.general.showOverlay = true;
      this.showError = false;

      this.searchIlimEdebiyatYayini(this.form).then(res => {
        this.$store.state.general.showOverlay = false;
        if(res.errorCode !== 0 && res.errorCode !== 118){
          this.errorHandling(res);
          console.log(res);
          //0790015341
          return;
        }
        if ((res.data && res.data.liste.length === 0) || !res.data) {
          this.showError = true;
          this.errorMessage = this.getMessage(118);
          this.$store.state.iy.searchList = true;
        }else{
          this.showError = false;
          this.errorMessage = "";
          this.$store.state.iy.searchList = true;
          this.$store.state.iy.ilimEdebiyatYayini.liste.forEach(element => {
            let mbCheck = this.mblist.filter(x => x.id === element.mbId);
            if(mbCheck.length > 0)
              element.mbName = mbCheck[0].name;
            if(element.ilimEdebiyatYayiniBaslik){
              let eserAdi = element.ilimEdebiyatYayiniBaslik.filter(x => x.baslikTipiKodu === "00");
              element.eserAdi = eserAdi.length > 0 ? eserAdi[0].baslik : "";
            }
          });

        }
      }).catch(() => {
        this.$store.state.general.showOverlay = false;
      });
    },
    getMBListOptions(){
      if(this.$store.state.auth.user.mbId !== 0)
        return;

      this.$store.state.general.showOverlay = true;
      this.getMBList().then(res => {
        if(res.errorCode == 0){
            this.mblist = res.data;
        }else{
            this.errorHandling(res);
        }
        this.$store.state.general.showOverlay = false;
      });
    },
    isEmptyFilterForm() {
      this.formTrimCheck(this.form);
      return (this.$store.state.auth.user.mbId !== 0 || this.form.mbId === 0)
        && this.form.eserAdi === ""
        && this.form.hakSahibiAdSoyad === ""
        && this.form.isbn === ""
        && this.form.uyeNo === ""
        && this.form.vergiNo === "";
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created() {
      this.getMBListOptions();
  },
  watch: {
    prevRoute(nw) {
      if (nw.name === 'ilim-edebiyat-yayini-detay' ||nw.name === 'ilim-edebiyat-yayini-detay-id') {
        if (Object.keys(this.$store.state.iy.duplicateForm).length > 0) {
          this.form = Object.assign({}, this.$store.state.iy.duplicateForm);
          if(this.$store.state.iy.searchList){
            this.list();
          }
        }
      } else {
        this.clear();
      }
    }
  },
  computed: {
    ...mapGetters('general', ['getMessage', 'getOptionWithParams', 'getFileLink', 'getLogAction', 'formTrimCheck'])
  }
};
</script>